import React from "react"
import ToolTip from "react-portal-tooltip"
import { grey500 } from "material-ui/styles/colors"
import * as api from "../../api"
import strings from "../../localization/strings"
interface IProps {
    shiftId: string
}
interface IState {
    open: boolean
    loaded: boolean
    shiftNote: string
}

export default class EmployeeShiftTooltip extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            loaded: false,
            shiftNote: null,
        }
    }

    getShiftNote() {
        !this.state.loaded &&
            api.getShiftNote(this.props.shiftId).then(res =>
                this.setState({
                    loaded: true,
                    shiftNote: res.data
                })
            )
    }

    render() {
        return (
            <div>
                <ToolTip active={this.state.open} position="right" arrow="center" parent={"#" + "shiftnote-" + this.props.shiftId}>
                    <div style={{ padding: 5, width: 200, overflowY: "auto", maxHeight: 300 }}>
                        {!this.state.shiftNote ?
                            <div style={{ textAlign: "center" }}>
                                {!this.state.loaded ?
                                    strings.loading :
                                    strings.No_Note
                                }
                            </div> :
                            <div>
                                {this.state.shiftNote}
                            </div>
                        }
                    </div>
                </ToolTip>
                <div style={{ marginTop: -5, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    <i
                        id={"shiftnote-" + this.props.shiftId}
                        className="fa fa-question-circle"
                        style={{ fontSize: 20, color: grey500 }}
                        onClick={() => this.setState({ open: true }, () => this.getShiftNote())}
                        onMouseOut={() => this.setState({ open: false })}
                    />
                </div>
            </div>
        )
    }
}